import { createAction } from 'redux-actions';

export const importData = createAction('IMPORT_DATA');
export const importDataSuccess = createAction('IMPORT_DATA_SUCCESS');
export const importDataFailure = createAction('IMPORT_DATA_FAILURE');

export const pfmImport = createAction('PFM_IMPORT');
export const pfmImportSuccess = createAction('PFM_IMPORT_SUCCESS');
export const pfmImportFailure = createAction('PFM_IMPORT_FAILURE');
